import Main from '../components/Main';
import Nav from '../components/Nav';

const AllCountries = () => {
  return (
    <div className="container">
      <Nav />
      <Main />
    </div>
  );
};

export default AllCountries;
